import React from "../../__snowpack__/pkg/react.js";
export const fallbackValAdd = (val) => {
  return val === 0 || val ? val : /* @__PURE__ */ React.createElement("span", {
    style: {color: "#6020FF"}
  }, "+Add");
};
